import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { OrderEditDiscount } from '../components/Products';

export function useEditOrderDiscountActions(
  editedOrderDiscounts: OrderEditDiscount[],
  setEditedOrderDiscounts: (editedDiscounts: OrderEditDiscount[]) => void,
  isOrderEdited: boolean,
  setIsOrderEdited: (isEdited: boolean) => void,
) {
  const t = useTranslationOrders();
  const handleAddDiscount = (newDiscount: { value: number }) => {
    const idx = editedOrderDiscounts.findIndex(
      (discount) => discount.discountType === 'coupon_discount',
    );

    if (idx === -1) {
      setEditedOrderDiscounts([
        ...editedOrderDiscounts,
        {
          id: 'editCouponDiscount',
          discountType: 'coupon_discount',
          name: t('editOrders.discountModal.customDiscount'),
          value: newDiscount.value,
          removed: false,
          prefix: '-',
          appearance: 'danger',
          editType: 'add',
        },
      ]);
    } else {
      const couponDiscount = editedOrderDiscounts[idx];
      const discountsBefore = editedOrderDiscounts.slice(0, idx);
      const discountsAfter = editedOrderDiscounts.slice(idx + 1);

      setEditedOrderDiscounts([
        ...discountsBefore,
        {
          ...couponDiscount,
          id: 'editCouponDiscount',
          name: t('editOrders.discountModal.customDiscount'),
          value: newDiscount.value,
        },
        ...discountsAfter,
      ]);
    }

    setIsOrderEdited(true);
  };

  const handleRemoveDiscount = (discountType: string) => {
    const discountToRemoveIdx = editedOrderDiscounts.findIndex(
      (discount) => discount.discountType === discountType,
    );

    if (discountToRemoveIdx === -1) return;

    const discountsBefore = editedOrderDiscounts.slice(0, discountToRemoveIdx);
    const discountsAfter = editedOrderDiscounts.slice(discountToRemoveIdx + 1);

    const updatedDiscounts = [...discountsBefore, ...discountsAfter];
    setEditedOrderDiscounts(updatedDiscounts);

    updateIsOrderDiscountsEdited(updatedDiscounts);
  };

  const updateIsOrderDiscountsEdited = (discounts: OrderEditDiscount[]) => {
    const isEdited = discounts.some((p) => p.editType !== undefined);
    if (isOrderEdited !== isEdited) {
      setIsOrderEdited(isEdited);
    }
  };

  return {
    handleAddDiscount,
    handleRemoveDiscount,
    isOrderEdited,
  };
}
